var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('search-panorama-excluded-subjects',{attrs:{"subjects":_vm.subjects},model:{value:(_vm.excludedSubjects),callback:function ($$v) {_vm.excludedSubjects=$$v},expression:"excludedSubjects"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }